import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFullScreen = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", { children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M9.33309 6.66797H7.33309C6.97947 6.66797 6.64033 6.78035 6.39028 6.98039C6.14023 7.18043 5.99976 7.45174 5.99976 7.73464V9.33464",
			stroke: "currentColor",
			strokeWidth: 1.66667,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17.3331 9.33464V7.73464C17.3331 7.45174 17.1926 7.18043 16.9426 6.98039C16.6925 6.78035 16.3534 6.66797 15.9998 6.66797H13.9998",
			stroke: "currentColor",
			strokeWidth: 1.66667,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.99976 14.668V16.668C5.99976 17.0216 6.14023 17.3607 6.39028 17.6108C6.64033 17.8608 6.97947 18.0013 7.33309 18.0013H9.33309",
			stroke: "currentColor",
			strokeWidth: 1.66667,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.9998 18.0013H15.9998C16.3534 18.0013 16.6925 17.8608 16.9426 17.6108C17.1926 17.3607 17.3331 17.0216 17.3331 16.668V14.668",
			stroke: "currentColor",
			strokeWidth: 1.66667,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	] })
});
export default SvgFullScreen;
